import { Box, BoxProps, Button, Stack } from '@mui/material';
import { sx, useAppTheme } from '@repo/ui';
import React from 'react';

export interface FormProps extends Omit<BoxProps, 'onSubmit'> {
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  submitLabel?: string;
  resetLabel?: string;
  onReset?: () => void;
  previousLabel?: string;
  onPrevious?: () => void;
  loading?: boolean;
  showActions?: boolean;
}

/**
 * Form container component with standardized styling and actions
 */
export const Form: React.FC<FormProps> = ({
  children,
  onSubmit,
  submitLabel = 'Submit',
  resetLabel = 'Reset',
  onReset,
  previousLabel = 'Previous',
  onPrevious,
  loading = false,
  showActions = true,
  ...props
}) => {
  const theme = useAppTheme();

  return (
    <Box
      component="form"
      noValidate
      onSubmit={(e: React.FormEvent<HTMLFormElement>) => onSubmit(e)}
      {...sx({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(3)
      })}
      {...props}
    >
      {children}

      {showActions && (
        <Stack direction="row" spacing={2} justifyContent="space-between" mt={2}>
          <Box>
            {onPrevious && (
              <Button
                type="button"
                variant="outlined"
                onClick={onPrevious}
                disabled={loading}
              >
                {previousLabel}
              </Button>
            )}
          </Box>
          <Stack direction="row" spacing={2}>
            {onReset && (
              <Button
                type="button"
                variant="outlined"
                onClick={onReset}
                disabled={loading}
              >
                {resetLabel}
              </Button>
            )}
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading}
            >
              {submitLabel}
            </Button>
          </Stack>
        </Stack>
      )}
    </Box>
  );
}; 